import { render, staticRenderFns } from "./Results.vue?vue&type=template&id=156a1d9d&scoped=true"
import script from "./Results.vue?vue&type=script&lang=js"
export * from "./Results.vue?vue&type=script&lang=js"
import style0 from "./Results.vue?vue&type=style&index=0&id=156a1d9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156a1d9d",
  null
  
)

export default component.exports